<template>
  <svg
    v-bind="$attrs"
    :width="width"
    :height="width"
    viewBox="0 0 19 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.6902 0C13.1769 0 13.6549 0.197641 13.9996 0.542292L17.6005 4.14318C17.95 4.49276 18.1427 4.95846 18.1427 5.45258V21H0.848633V0H12.6902ZM11.9663 1.23529H2.08391V19.7647H16.9074V6.17647H11.9663V1.23528L11.9663 1.23529ZM13.2016 1.491V4.94118H16.6517L13.2016 1.491Z"
      :fill="fill"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.84892 7.41211C9.14169 7.41211 9.39987 7.55047 9.59257 7.82593C10.0509 8.47199 10.0188 9.16004 9.84952 10.0865C9.79146 10.4052 9.85075 10.7276 10.0274 10.9957C10.2769 11.3762 10.6364 11.8999 10.9897 12.3434C11.2491 12.6708 11.6481 12.8449 12.052 12.7906C12.3115 12.7548 12.624 12.7251 12.9452 12.7251C14.3781 12.7251 14.2706 13.2365 14.4003 13.7059C14.472 13.99 14.4362 14.2383 14.2892 14.4224C14.1063 14.6707 13.7296 14.7992 13.1786 14.7992C12.5684 14.7992 12.367 14.6954 11.8359 14.5262C11.5357 14.4298 11.2244 14.41 10.9205 14.4903C10.314 14.6485 9.31339 14.8893 8.47834 15.0042C8.03239 15.066 7.62723 15.2958 7.35792 15.67C6.75139 16.51 6.18934 17.2945 5.29869 17.2945C5.06892 17.2945 4.85769 17.2117 4.68352 17.0462C4.42657 16.7892 4.31663 16.5039 4.37099 16.1728C4.52169 15.1562 5.77181 14.5892 6.51546 14.1753C6.69087 14.0777 6.82923 13.9283 6.91569 13.743L8.09541 11.1921C8.17941 11.013 8.20534 10.8141 8.17446 10.6177C8.03734 9.75299 7.83474 8.29905 8.37952 7.64187C8.49934 7.49487 8.66488 7.41211 8.84892 7.41211ZM9.07375 11.1303C8.60063 12.5151 7.76434 14.0209 7.65192 14.1963C8.66116 13.722 10.6698 13.4823 10.6698 13.4823C9.65928 12.5089 9.07375 11.1303 9.07375 11.1303Z"
      :fill="fill"
    />
  </svg>
</template>

<script lang="ts" setup>
defineProps({
  width: {
    type: [String, Number],
    default: 19,
  },
  height: {
    type: [String, Number],
    default: 21,
  },
  fill: {
    type: String,
    default: 'currentColor',
  }
});
</script>